import { routes as communications } from "@pages/s1/communications/communications.routes";
import { routes as counters } from "@pages/s1/counters/counters.routes";
import { routes as credit } from "@pages/s1/credit/credit.routes";
import { routes as customers } from "@pages/s1/customers/customers.routes";
import { routes as ecl } from "@pages/s1/ecl/ecl.routes";
import { routes as finance } from "@pages/s1/finance/finance.routes";
import { routes as forms } from "@pages/s1/forms/forms.routes";
import { routes as hrResources } from "@pages/s1/hrResources/hrResources.routes";
import { routes as hvac } from "@pages/s1/hvac/hvac.routes";
import { routes as incidents } from "@pages/s1/incidents/incidents.routes";
import { routes as marketing } from "@pages/s1/marketing/marketing.routes";
import { routes as operations } from "@pages/s1/operations/operations.routes";
import { routes as opisPrices } from "@pages/s1/opisPrices/opisPrices.routes";
import { routes as pcm } from "@pages/s1/pcm/pcm.routes";
import { routes as posts } from "@pages/s1/posts/posts.routes";
import { routes as pricing } from "@pages/s1/pricing/pricing.routes";
import { routes as reports } from "@pages/s1/reports/reports.routes";
import { routes as s1Root } from "@pages/s1/s1.routes";
import { routes as s1DataAdmin } from "@pages/s1/s1DataAdmin/s1DataAdmin.routes";
import { routes as s1Logging } from "@pages/s1/s1Logging/s1Logging.routes";
import { routes as s1SystemsAdmin } from "@pages/s1/s1SystemsAdmin/s1SystemsAdmin.routes";
import { routes as tickets } from "@pages/s1/tickets/tickets.routes";
import { routes as wholesale } from "@pages/s1/wholesale/wholesale.routes";

export const routes = [
  ...s1Root,
  ...counters,
  ...credit,
  ...customers,
  ...ecl,
  ...finance,
  ...forms,
  ...hrResources,
  ...hvac,
  ...incidents,
  ...marketing,
  ...operations,
  ...opisPrices,
  ...pcm,
  ...pricing,
  ...reports,
  ...s1DataAdmin,
  ...s1Logging,
  ...s1SystemsAdmin,
  ...tickets,
  ...wholesale,
  ...communications,
  ...posts,
];
